module.exports = __webpack_public_path__ + "img/complete.35e34ec9.png";